export const resolveViewMode = (activeTab, viewMode) =>
  activeTab ? viewMode : "all";

export const getVisibleMessages = (messages, activeTab, viewMode) => {
  const effectiveViewMode = resolveViewMode(activeTab, viewMode);
  if (effectiveViewMode === "all") {
    return messages;
  }
  return messages.filter((msg) => msg.activeTab === activeTab);
};

export const hasOtherTabTurns = (messages, activeTab) =>
  messages.some((msg) => msg.activeTab !== activeTab);

export const buildMessageKey = (msg, idx) =>
  msg._localId || msg._seq || `thread-msg-${idx}`;
